// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__ExpandTrigger__button{background:none;color:var(--GW-TABLE-VIEW-COLOR);height:auto;padding:0;width:auto}", "",{"version":3,"sources":["webpack://./../../../../../src/dataview/features/expandable/cells/ExpandTrigger.module.scss","webpack://./../../platform/@jutro/legacy/dataview/features/expandable/cells/ExpandTrigger.module.css"],"names":[],"mappings":"AAAA,4BAKE,eAAA,CADA,gCAAA,CAHA,WAAA,CAEA,SAAA,CADA,UCIF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "jut__ExpandTrigger__button"
};
export default ___CSS_LOADER_EXPORT___;
